export const headerLinks = [
  { text: 'Faucet', href: '/' },
  { text: 'Explorer', href: 'https://explorer-testnet.cratd2csmartchain.io/' },
  {
    text: 'Quick Wallet Set-Up',
    href: 'https://cratd2csmartchain.gitbook.io/cratd2c-blockchain-testnet-and-mainnet-transition/quick-wallet-set-up-usdcratd2c-network',
  },
  { text: 'BUY ICO', href: 'https://cratd2csmartchain.io/' },
];
